import React, { useEffect, useState } from "react";


interface DeleteOfferModalProps {
    onClose: () => void;
    offer_id: number;
    onConfirm: () => void;
    isSupply: boolean;
}

export default function DeleteOfferModal({
    onClose,
    offer_id,
    onConfirm,
    isSupply

}: DeleteOfferModalProps) {


    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
            <div className="bg-white dark:bg-gray-800 rounded-xl p-6 w-96 shadow-lg max-h-[90vh] overflow-y-auto">
                <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">
                    Deleting {isSupply ? "Supply" : "Offer"} {offer_id}
                </h2>

                <p className="mb-4 text-gray-700 dark:text-gray-300">
                    Are you sure you want to delete it?
                </p>

                <div className="flex justify-end gap-3">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 rounded-lg bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-600"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onConfirm}
                        className="px-4 py-2 rounded-lg bg-red-600 text-white hover:bg-red-700"
                    >
                        Delete
                    </button>
                </div>
            </div>
        </div>
    );
}
